import {
  Input,
  TemplateRef
} from '@angular/core';

import {
  SkyAutocompleteSearchFunction,
  SkyAutocompleteSearchFunctionFilter
} from '../autocomplete';

export class SkyLookupAutocompleteAdapter {
  
  public data: any[];

  
  public descriptorProperty: string;

  
  public propertiesToSearch: string[];

  
  public search: SkyAutocompleteSearchFunction;

  
  public searchResultTemplate: TemplateRef<any>;

  
  public searchTextMinimumCharacters: number;

  
  public searchFilters: SkyAutocompleteSearchFunctionFilter[];

  
  public searchResultsLimit: number;
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'data': [{ type: Input },],
'descriptorProperty': [{ type: Input },],
'propertiesToSearch': [{ type: Input },],
'search': [{ type: Input },],
'searchResultTemplate': [{ type: Input },],
'searchTextMinimumCharacters': [{ type: Input },],
'searchFilters': [{ type: Input },],
'searchResultsLimit': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
